import { type ReactNode } from "react";

/**
 * Container component to center content with a maximum width.
 * @param {Object} props - Component properties.
 * @param {React.ReactNode} props.children - Content to be rendered inside the container.
 * @param {string} [props.className] - Optional additional CSS classes for styling.
 * @returns {JSX.Element} A div element that wraps the children with specified styles.
 */

interface ContainerProps {
  children: ReactNode;
  className?: string;
}

export default function Container({ children, className = "" }: ContainerProps) {
  return <div className={`w-full max-w-[670px] mx-auto pb-20 ${className}`}>{children}</div>;
}
